import React from "react";
import OwnerRoutes from "./OwnerRoutes";

const OwnerDashboard: React.FC = () => {
  return (
    <>
        <OwnerRoutes />
    </>
  );
};

export default OwnerDashboard;
